import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const IndexPage = withSafeSuspense(lazy(
  async () => ({ default: (await import('./index_page')).IndexPage })
))
